module.exports = __webpack_public_path__ + "static/media/1POLICY16.64189529.jpg";